<template>
 <div class="createDomain">
   <main class="t-main">
   <ol class="m-breadcrumb">
     <li class="m-breadcrumb__item"><router-link class="a-text a-link" to="/delivery/list-domain">ドメイン一覧</router-link></li>
     <li class="m-breadcrumb__item"><span class="a-text">ドメイン登録</span></li>
   </ol>
  <h1 class="a-title">{{ createDomainTitle }}</h1>
  <div class="m-form__item-wrapper">
    <div class="m-form__item m-form__item--50">
      <label class="m-form__label">fqdn<span class="m-form__label--necessary">※必須</span>
        <input class="m-form__input m-form__input--text" type="text"　v-model="tasks.fqdn" placeholder="例：example.com">
      </label>
    </div>
  </div>
  <p class="a-button__wrapper">
    <button class="a-button" v-on:click="createdomain">登録</button>
    <button class="a-button a-button--cansel" v-on:click="golistdomain">キャンセル</button>
  </p>
</main>
 </div>
</template>

<script>
import store from '../../../stores'
import { includes } from 'lodash'
import { domainRegexp } from '../../../constants'

export default {
  name: 'createDomain',
  data() {
    return {
      createDomainTitle: 'ドメイン登録'
    }
  },
  created() {
    store.dispatch('formatDomainData')
  },

  computed: {
    tasks: { get() { return store.state.domain.domain } },
    // バリデーション関数を定義する
    validation: function () {
      return {
        fqdn: domainRegexp.test(this.tasks.fqdn)
      }
    },
    // バリデーションを読み込む関数
    isValid: function () {
      let msg = []
      if (this.tasks.fqdn === '') {
        msg.push('fqdnは必須です')
      } else if (includes(this.validation, false) || this.tasks.fqdn.length > 150) {
        msg.push('入力項目に不備があります(150文字以内, e.g. example.com)')
      }
      return msg.join('\n')
    }
  },

  methods: {
    createdomain: function() {
      var errMsg = this.isValid
      if (errMsg === '') {
        store.dispatch('checkSessionId')
        store.dispatch('createdomain', this.$router)
      } else {
        alert(errMsg)
      }
    },
    golistdomain: function() {
      this.$router.push('/delivery/list-domain')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/delivery/domain/CreateDomain.vue